import type { Scope } from './types'

export const DEFAULT_VIEW_STATE_ID = 'unknown'

export const UNKNOWN_VIEW_STATE_SCOPE = 'unknown'

export const LAST_ACTIVE_LOCAL_STORAGE_KEY = 'horizon:viewState:lastActive'

export const DEFAULT_VIEW_STATE_SCOPE: Scope = {
  type: 'Unknown',
  scope: '',
  id: 'default_scope',
}
